import * as React from "react";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import { Button, Grid } from "@mui/material";
import Divider from "@mui/material/Divider";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  textAlign: "center",
  color: "white",
  backgroundColor: "transparent !important",
}));
const theme = createTheme();

theme.typography.h3 = {
  fontSize: "28px",
  "@media (min-width:600px)": {
    fontSize: "30px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "30px",
  },
};
theme.typography.h5 = {
  fontSize: "16px",
  padding: "25px !important",
  "@media (min-width:600px)": {
    fontSize: "18px",
    padding: "25px !important",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "20px",
  },
};

const Achievements = () => {
  return (
    <Box id="achievements" sx={{ textAlign: "center" }}>
      <ThemeProvider theme={theme}>
        <Typography
          gutterBottom
          variant="h3"
          component="div"
          sx={{ textAlign: "center", my: 1, py: 4 }}
        >
          ACHIEVEMENTS
          <Divider variant="middle" />
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            <Grid item xs sx={{ pb: 1 }}>
              <Item>
                {" "}
                <Typography variant="h5" className="skillsbgok">
                  1+ <br /> Open Source Contribution
                  <a
                    href="https://github.com/mui-org/material-ui/pull/29829"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button> #29829 </Button>
                  </a>{" "}
                </Typography>
              </Item>
            </Grid>
            <Grid item xs sx={{ pb: 1 }}>
              <Item>
                {" "}
                <Typography variant="h5" className="skillsbgok">
                  50+ <br /> GitHub Repository
                </Typography>
              </Item>
            </Grid>
            <Grid item xs sx={{ pb: 1 }}>
              <Item>
                {" "}
                <Typography variant="h5" className="skillsbgok">
                  19+ <br /> Github Followers
                </Typography>
              </Item>
            </Grid>
            <Grid item xs sx={{ pb: 1 }}>
              <Item>
                {" "}
                <Typography variant="h5" className="skillsbgok">
                  500+ <br /> Github Stars
                </Typography>
              </Item>
            </Grid>
          </Grid>
        </Box>
      </ThemeProvider>
    </Box>
  );
};

export default Achievements;

//rgb(25, 49, 96) none repeat scroll 0% 0%
